import React, {useState} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {a11yProps, TabPanel, useStylesTab} from "../Shared/Tab/TabPanel";
import PendingShipmentComponent from "./PendingShipment/PendingShipmentComponent";
import ScheduleShipmentComponent from "./ScheduleShipment/ScheduleShipmentComponent";
import PickupShipmentComponent from "./PickupShipment/PickupShipmentComponent";
import AllShipmentsComponent from "./AllShipments/AllShipmentsComponent";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {Fab, Zoom} from "@material-ui/core";
import {ModalActions} from "../../Store/Modal/Slice";
import {PICKUP_MODAL} from "../../Store/Modal/Types";
import {useDispatch, useSelector} from "react-redux";
import {PaymentTypeActions} from "../../Store/PaymentType/Slice";
import {PackingTypesActions} from "../../Store/PackingType/Slice";
import {ContactsActions} from "../../Store/Contact/Slice";
import {Customer} from "../../Models/Customer";
import {RootState} from "../../Store/Reducers";

const TabComponent = () => {

  const classes = useStylesTab();
  const dispatch = useDispatch();

  const {CompanyReducer: {company_selected, branch_selected}} = useSelector((state: RootState) => state);

  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const FABS = [
    {
      color: 'secondary' as 'secondary',
      className: classes.fab,
      icon:<FontAwesomeIcon icon={faPlus} />,
      label: 'Add',
    }
  ];

  const openNewShipmentModal = () => {
    dispatch(ModalActions.openModal({modal:PICKUP_MODAL}));
    dispatch(ContactsActions.getContacts({customer:(branch_selected as Customer)?._KEY || (company_selected as Customer)?._KEY}));
    dispatch(PackingTypesActions.getPackingTypes());
    dispatch(PaymentTypeActions.getPaymentTypes());
  };

  return (
    <div className={classes.root }>

      <AppBar className="custom-tab" position="static" elevation={0} color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          //centered
          className={classes.mainTab}
          aria-label="scrollable auto tabs example"
        >

          <Tab className="outline-none default-font" label="Todos" {...a11yProps(0)} />
          <Tab className="outline-none default-font" label="Pendiente" {...a11yProps(1)} />
          <Tab className="outline-none default-font" label="Agendada" {...a11yProps(2)} />
          <Tab className="outline-none default-font" label="Recogida" {...a11yProps(3)} />
        </Tabs>
      </AppBar>

      <TabPanel children={<AllShipmentsComponent/>} value={value} index={0}/>

      <TabPanel children={<PendingShipmentComponent/>} value={value} index={1}/>

      <TabPanel children={<ScheduleShipmentComponent/>} value={value} index={2}/>

      <TabPanel children={<PickupShipmentComponent/>} value={value} index={3}/>

      {FABS.map((fab) => (
        <Zoom
          key={fab.color}
          in
        >
          <Fab onClick={openNewShipmentModal} className={fab.className+" outline-none"} color={fab.color}>
            {fab.icon}
          </Fab>
        </Zoom>
      ))}

    </div>
  );
};

export default TabComponent;
